<template>
  <div class="chart-box">
    <div class="chart-box-title">
      <em>{{ title }}</em>
    </div>
    <div :id="id" class="echarts-class" v-if="id"></div>
    <slot></slot>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import 'echarts-gl'
import {markRaw} from "vue";
export default {
  props: {
    title: {
      type: String,
      default: 'echartsBox'
    },
    id: {
      type: String,
      default: ''
    },
  },
  name: 'echartsBox',
  data() {
      return {
        myCharts: null
      }
  },
  mounted() {

  },
  methods: {
    initEcharts(options) {
      this.myCharts = markRaw(echarts.init(document.getElementById(this.id)))
      this.myCharts.setOption(options)
      window.addEventListener('resize', () => {
        this.myCharts.resize()
      })
    }
  }
}
</script>
<style scoped lang="scss">
.chart-box {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .chart-box-title {
    height: 4.2vh;
    line-height: 3.3vh;
    padding: 0 2vw;
    background-image: url("../../../assets/images/industrialOperation/title-bg.png");
    background-size: 88% auto;
    background-repeat: no-repeat;
    background-position: center bottom -0.5vh;
    font-size: 1.06vw;
    color: #fff;
    font-family: Alibaba-PuHuiTi-B;
    text-indent: 2.3em;
  }
  .echarts-class {
    flex: 1;
  }
}
</style>
